<div class="notfound">
  <div class="nfcontent">
    <fa-icon [icon]="faWarning" size="6x"></fa-icon>
    <h1>Page Not Found</h1>
    <p>The page you are looking for could not be found.</p>
  </div>
</div>